export class DamageFlash {
    private scene: Phaser.Scene;
    private flashOverlay: Phaser.GameObjects.Graphics | null = null;
    private flashTween: Phaser.Tweens.Tween | null = null;

    constructor(scene: Phaser.Scene) {
        this.scene = scene;
    }

    /**
     * Creates the flash overlay graphics object
     */
    private createFlashOverlay(): void {
        if (this.flashOverlay) {
            this.flashOverlay.destroy();
        }

        // Create a graphics object for the screen border flash
        this.flashOverlay = this.scene.add.graphics();
        this.flashOverlay.setScrollFactor(0); // Fixed to camera
        this.flashOverlay.setDepth(999999); // Very high depth to ensure it's on top
        this.flashOverlay.setAlpha(0); // Start invisible

        // Draw red border around the screen
        const { width, height } = this.scene.scale;
        const borderThickness = 20; // Thickness of the border flash

        this.flashOverlay.fillStyle(0xff0000, 1); // Red color

        // Top border
        this.flashOverlay.fillRect(0, 0, width, borderThickness);
        // Bottom border
        this.flashOverlay.fillRect(0, height - borderThickness, width, borderThickness);
        // Left border
        this.flashOverlay.fillRect(0, 0, borderThickness, height);
        // Right border
        this.flashOverlay.fillRect(width - borderThickness, 0, borderThickness, height);
    }

    /**
     * Triggers the red flash effect
     */
    flash(): void {
        // Stop any existing flash animation
        if (this.flashTween) {
            this.flashTween.stop();
            this.flashTween = null;
        }

        // Create the flash overlay if it doesn't exist
        this.createFlashOverlay();

        if (!this.flashOverlay) {
            return;
        }

        // Animate the flash effect
        this.flashTween = this.scene.tweens.add({
            targets: this.flashOverlay,
            alpha: { from: 0.7, to: 0 }, // Start visible, fade to invisible
            duration: 400, // Flash duration in milliseconds
            ease: 'Power2.easeOut',
            onComplete: () => {
                this.flashTween = null;
                // Clean up the overlay after animation
                if (this.flashOverlay) {
                    this.flashOverlay.destroy();
                    this.flashOverlay = null;
                }
            }
        });
    }

    /**
     * Cleans up the damage flash component
     */
    destroy(): void {
        if (this.flashTween) {
            this.flashTween.stop();
            this.flashTween = null;
        }

        if (this.flashOverlay) {
            this.flashOverlay.destroy();
            this.flashOverlay = null;
        }
    }
}